import { Controllers, IsBadRequestResult, IsForbiddenResult, IsNotFoundResult, IsServerErrorResult, ProblemResult } from "@infoland/iprova-api";
import { CommunityLink } from "./types";

export * from "./types";

export default {
    async getCommunityLinksAsync(route: string, includeFallback: boolean = false): Promise<CommunityLink[] | null> {
        const path: string = route
            ? `community_links?regex_matches=${encodeURIComponent(route)}&include_fallback=${includeFallback}`
            : "community_links";
        const response: CommunityLink[] | ProblemResult<string> = await Controllers.GenericController.getAsync<
            CommunityLink[] | ProblemResult<string>
        >(path);
        if (!(IsServerErrorResult(response) || IsBadRequestResult(response) || IsForbiddenResult(response) || IsNotFoundResult(response))) {
            return response;
        } else {
            return null;
        }
    }
};
